<template>
  <div
    id="date-picker"
    :class="{ 'report-wrap': onReportsBuilder, wrap: !onReportsBuilder }"
    @click="toggleDatePicker()"
  >
    <input ref="b-datepicker-inp" readonly autocomplete="off" @click.stop />
  </div>
</template>

<script>
import $ from 'jquery';
import { get } from 'vuex-pathify';
import '../../util/b-datepicker-jq';
import {
  DATEPICKER_RANGE_OPTIONS,
  DATEPICKER_COMPARE_RANGE_OPTIONS,
  RANGE_CAMPAIGN_TO_DATE,
} from '~/constant';
import { convertEpochToNYTimezone } from '~/util/utility-functions';

export default {
  props: {
    week1: {
      type: Array,
      required: false,
      default: () => [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(new Date().setDate(new Date().getDate() - 1)),
      ],
    },
    week2: {
      type: Array,
      required: false,
      default: () => [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(new Date().setDate(new Date().getDate() - 2)),
      ],
    },
    campaignOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    compareWithText: {
      type: String,
      required: false,
      default: 'Compared with:',
    },
    activeSolutionId: {
      type: Number,
      required: false,
      default: 1,
    },
    hideCompareWith: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    showAdditionalOption: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    showCampaignToDate: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    allowLatestDateSelection: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    onReportsBuilder: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      minCampaignDate: '',
      showDatePicker: false,
    };
  },

  computed: {
    dates: get('dashboard/dates'),
    isEmbedMode: get('common/isEmbedMode'),
  },
  watch: {
    campaignOptions(campaigns = []) {
      this.fetchMinCampaignStartDate(campaigns);
      // const { dateRangeOption, dateCompareOption } = this.dates;
      const { dateRangeOption } = this.dates;
      let { compareWith } = this.dates;
      const today = new Date();
      const twoDaysAgo = new Date(today);
      twoDaysAgo.setDate(today.getDate() - 2);
      if (dateRangeOption === RANGE_CAMPAIGN_TO_DATE && this.minCampaignDate !== '') {
        const dates = [
          new Date(this.minCampaignDate),
          new Date(new Date().setDate(new Date().getDate() - 2)),
        ];

        // Add last two items only if hideCompareWith is false
        if (!this.hideCompareWith) {
          dates.push(new Date(this.minCampaignDate));
          dates.push(new Date(new Date().setDate(new Date().getDate() - 2)));
        } else {
          // If hideCompareWith is true, set compareWith to false
          compareWith = false;
        }

        // this.$emit('change', {
        //   dates,
        //   compareWith,
        //   dateRangeOption,
        //   dateCompareOption,
        // });

        $(this.$refs['b-datepicker-inp']).DatePickerDisplayText({ dates, compareWith });

        // Set date2 based on whether hideCompareWith is true or false
        if (!this.hideCompareWith && dates.length === 4) {
          $(this.$refs['b-datepicker-inp']).DatePickerSetDate(
            {
              date: [convertEpochToNYTimezone(dates[0]), convertEpochToNYTimezone(dates[1])],
              date2: [convertEpochToNYTimezone(dates[2]), convertEpochToNYTimezone(dates[3])],
            },
            true
          );
        } else {
          $(this.$refs['b-datepicker-inp']).DatePickerSetDate(
            {
              date: [convertEpochToNYTimezone(dates[0]), convertEpochToNYTimezone(dates[1])],
              date2: null, // or date2: []
            },
            true
          );
        }
      }
    },
  },
  mounted() {
    const vm = this;
    this.fetchMinCampaignStartDate(this.campaignOptions);
    // Remove duplicate datepickers
    const prevDatePickerElements = document.querySelectorAll('[id*="datepicker_"]');
    if (prevDatePickerElements?.length > 0) {
      prevDatePickerElements.forEach((elm) => elm.remove());
    }
    const prevDatePickerIdElements = document.querySelectorAll('#date-picker');
    if (prevDatePickerIdElements?.length > 1) {
      prevDatePickerIdElements.forEach((elm, index) => {
        if (index === 0) elm.remove();
      });
    }
    $.curCSS = function(element, prop, val) {
      return $(element).css(prop, val);
    };
    const to = new Date();
    this.$nextTick(() => {
      $(vm.$refs['b-datepicker-inp']).DatePicker({
        inline: false,
        date: [vm.week1[0], vm.week1[1]],
        date2: vm.hideCompareWith ? [] : [vm.week2[0], vm.week2[1]],
        comparable: true,
        compareWith: vm.hideCompareWith ? false : this.dates.compareWith,
        calendars: 3,
        mode: 'range',
        position: 'bottom',
        dayDifference: 0,
        instantlyApply: false,
        compareWithText: this.compareWithText,
        constants: { DATEPICKER_RANGE_OPTIONS, DATEPICKER_COMPARE_RANGE_OPTIONS },
        current: new Date(to.getFullYear(), to.getMonth() - 1, 1),
        language: 'en', // en is default,
        isHideCompareWith: vm.hideCompareWith,
        showAdditionalOption: vm.showAdditionalOption,
        onReportsBuilder: vm.onReportsBuilder,
        showCampaignToDate: vm.showCampaignToDate,
        allowLatestDateSelection: vm.allowLatestDateSelection,
        allowToday: vm.allowLatestDateSelection,
        isEmbedMode: vm.isEmbedMode,
        onChange(dates, something, compareWith, dateRangeOption, dateCompareOption) {
          vm.$emit('change', {
            dates,
            compareWith,
            dateRangeOption,
            dateCompareOption,
          });
        },
        onAfterHide: () => {
          $(vm.$refs['b-datepicker-inp']).DatePickerSetDate({ date: vm.week1, date2: vm.week2 });
        },
        getDefaultOptions: () => {
          return {
            startDate: convertEpochToNYTimezone(this.dates.startDate),
            endDate: vm.hideCompareWith ? [] : convertEpochToNYTimezone(this.dates.endDate),
            compareWith: vm.hideCompareWith ? false : this.dates.compareWith,
            dateRangeOption: this.dates.dateRangeOption,
            dateCompareOption: this.dates.dateCompareOption,
          };
        },
        getMinCampaignDate: () => {
          return this.minCampaignDate;
        },
      });
    });
  },
  beforeDestroy() {
    const vm = this;
    $(vm.$refs['b-datepicker-inp']).DatePickerHide();
  },
  methods: {
    fetchMinCampaignStartDate(campaigns = []) {
      let selectedCampaigns = campaigns.filter((val) => val.checked);
      if (!selectedCampaigns.length) {
        selectedCampaigns = campaigns;
      }
      const startDates = selectedCampaigns.map((filterVal) => filterVal.startDate);
      if (startDates.length === 0) {
        this.minCampaignDate = '';
        return;
      }
      const minStartDate = startDates.sort()[0];
      this.minCampaignDate = convertEpochToNYTimezone(new Date(minStartDate));
    },
    toggleDatePicker() {
      const vm = this;
      if (this.showDatePicker) {
        $(vm.$refs['b-datepicker-inp']).DatePickerHide();
      }
      this.showDatePicker = !this.showDatePicker;
    },
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 600px) {
  /*div.datepicker {margin: 10px 0px 0px -496px;}
*/

  .datepicker {
    max-width: 250px !important;
    margin: 10px 0px !important;
  }
  .datepickerBlock .cal-picker-wrap,
  .datepickerSpace,
  td.datepickerBlock.cal-picker-wrap {
    display: none !important;
  }
  .compare {
    padding: 0px 0px 0px 0px;
  }
}
.wrap {
  position: relative;
  min-width: 255px;
}

/* Datepicker border styling */
.datepicker {
  padding: 8px 30px 10px;
  background-color: #edeef1;
  border: 0px solid #cccccc;
  border-radius: 4px;
}
.datepickerContainer {
  margin-left: -12px;
}

.cal-prevnext {
  position: relative;
  top: 1px;
  font-size: 18px;
}

.datepickerGoNext span,
.datepickerGoPrev span {
  position: absolute;
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: -10px;
  font-size: 10px;
}

.datepickerGoNext span:hover,
.datepickerGoPrev span:hover {
  opacity: 0.7;
}
.datepickerGoPrev span:before {
  position: absolute;
  top: 50%;
  right: 8px;
  margin-top: -10px;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  font-variant: normal;
  color: #fff;
  content: '\25C0';
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}
.datepickerGoNext span:before {
  position: absolute;
  top: 50%;
  right: 6px;
  margin-top: -10px;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  font-variant: normal;
  color: #fff;
  content: '\25BA';
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

/* Tighten up the spacing between multiple calendars */
.datepickerSpace div {
  width: 2px;
}

/* Grey background behind Month Name row, and blue text */
div.datepicker th {
  background-color: #dddddd;
}

div.datepicker th a.datepickerMonth {
  font-size: 1em;
  font-weight: normal;
  color: #ffffff;
}

/* style the day of week header cells */
div.datepicker th {
  font-weight: bold;
  color: #f00;

  /* cursor: pointer; */
}

/* grey underline beneath day of week row */
div.datepicker table thead tr.datepickerDoW th {
  border-bottom: 1px solid #cccccc;
}

/* Black text, white background, and grey borders around day cells */
div.datepicker a,
div.datepicker a:hover {
  color: #787878;
}

div.datepicker table.datepickerViewDays,
div.datepicker table.datepickerViewMonths,
div.datepicker table.datepickerViewYears {
  background-color: white;
}
table.datepickerViewDays {
  border-radius: 4px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}

div.datepicker table tbody.datepickerDays td {
  // border: 1px solid #f7f7f7;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* blue cell color for selected days */
tbody.datepickerDays td.datepickerSelected {
  background-color: #0077cc;
}

/* Grey out dates in the future */
div.datepicker td.datepickerFuture a {
  color: #dddddd;
  pointer-events: auto;

  &:hover:after {
    content: 'Data is available up to two days prior to the current date';
    position: fixed;
    font-size: 10px;
    padding: 5px;
    background-color: dimgray;
    color: white;
    opacity: 0.8;
    border-radius: 5px;
    z-index: 99999 !important;
  }
}

/* yellow cell background on hover */
div.datepicker tbody.datepickerDays td:hover {
  background-color: #ddd;
}

/* Bold today's date */
div.datepicker td.datepickerToday a {
  font-weight: bold;
  box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 0.3);
}

/* cells are wider in the clean style */
.datepickerYears a,
.datepickerMonths a {
  width: 42px;
}

.datepickerMonths td:first-child a,
.datepickerYears td:first-child a {
  width: 39px;
}

div.datepicker th a.datepickerMonth {
  width: 121px;
}

div.datepicker {
  // position: relative;
  position: absolute;
  top: 122px !important;
  left: 0;
  z-index: 999;
  display: none;
  width: 196px;
  height: 207px !important;
  margin: 10px 0px 0px 244px;

  /*font-family: Arial, Helvetica, sans-serif;*/
  font-size: 12px;
  cursor: default;
  border: 1px solid #fff;
  box-shadow: 1px 1px 16px 1px rgba(0, 0, 0, 0.4);
}

.datepickerContainer {
  position: absolute;
}

/* Hide border divs by default */
// .datepickerBorderT,
// .datepickerBorderB,
// .datepickerBorderL,
// .datepickerBorderR,
// .datepickerBorderTL,
// .datepickerBorderTR,
// .datepickerBorderBL,
// .datepickerBorderBR {
//   display: none;
// }

.datepickerHidden {
  display: none;
}

div.datepicker table {
  border-collapse: collapse;
}

div.datepicker a {
  color: #787878;
  text-decoration: none;
  cursor: default;
  outline: none;
}

div.datepicker table td {
  padding: 1px 1px !important;
  margin: 0;
  text-align: center;
  widows: 100%;
}

div.datepicker th {
  padding: 3px;
  font-size: 0.91em;
  font-weight: normal;
  // color: #666666;

  /* padding: 5px 5px; */
  color: #2f323a;
  text-align: center;
  background: white;

  /* border-bottom: 1px solid #eee!Important; */
}

div.datepicker thead tr:first-child th.hmtitle {
  height: 26px;
  padding: 3px;
  font-size: 1em;
  background-color: #2f323a;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

div.datepicker tbody a {
  display: block;
  cursor: pointer;
}

.datepickerDays a {
  width: 20px;
  height: 16px;
  padding-right: 2px;
  line-height: 16px;
}

.datepickerYears a,
.datepickerMonths a {
  width: 39px;
  height: 36px;
  line-height: 36px;
  text-align: center;
}

.datepickerMonths td:first-child a,
.datepickerMonths td:last-child a,
.datepickerYears td:first-child a,
.datepickerYears td:last-child a {
  width: 38px;
}

td.datepickerNotInMonth a {
  color: #666666;
  pointer-events: none !important;
}

tbody.datepickerDays td.datepickerSelected {
  background: var(--primarycolor);
}

tbody.datepickerDays td.datepickerNotInMonth.datepickerSelected {
  background: #2f323a;
}

tbody.datepickerYears td.datepickerSelected,
tbody.datepickerMonths td.datepickerSelected {
  background: #17384d;
}

div.datepicker td.datepickerSelected a {
  color: white;
}

div.datepicker a:hover,
div.datepicker a:hover {
  color: #586167;
}

div.datepicker td.datepickerNotInMonth a:hover {
  color: #999999;
}

.datepickerSpace div {
  width: 10px;
}

.datepickerBlock {
  vertical-align: top;
}

a.datepickerGoNext,
a.datepickerGoPrev,
a.datepickerMonth {
  float: left;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

div.datepicker th a.datepickerGoNext,
div.datepicker th a.datepickerGoPrev {
  display: none;
  width: 19px;
  // color: #666666;
  color: #ffffff;
}

div.datepicker th a.datepickerMonth {
  display: block;
  width: 113px;
}

/* Only display the previous/next arrows on the first/last calendars */
div.datepicker .datepickerFirstView th a.datepickerGoPrev,
div.datepicker .datepickerLastView th a.datepickerGoNext {
  display: block;
}

div.datepicker .datepickerLastView th a.datepickerGoNext {
  float: right;
}

/* Compensate for the space lost by not having a previous arrow */
div.datepicker th a.datepickerMonth {
  margin-left: 20px;
}

div.datepicker .datepickerFirstView th a.datepickerMonth {
  margin-left: 0;

  /* margin-right: 20px; */
}

/* Day mode calendar body */
table.datepickerViewDays tbody.datepickerMonths,
table.datepickerViewDays tbody.datepickerYears {
  display: none;
}

/* Month mode calendar body */
table.datepickerViewMonths tbody.datepickerDays,
table.datepickerViewMonths tbody.datepickerYears,
table.datepickerViewMonths tr.datepickerDoW {
  display: none;
}

/* Year mode calendar body */
table.datepickerViewYears tbody.datepickerDays,
table.datepickerViewYears tbody.datepickerMonths,
table.datepickerViewYears tr.datepickerDoW {
  display: none;
}

td.datepickerDisabled a,
td.datepickerDisabled.datepickerNotInMonth a {
  color: #555555;
}

td.datepickerDisabled a:hover {
  color: #333333;
}

/* Not used by default, calendar cells can be marked as special if desired (doesn't seem to be totally working) */
div.datepicker tbody.datepickerDays td.datepickerSpecial a {
  color: white;
  background: #770000;
}

div.datepicker tbody.datepickerDays td.datepickerSpecial.datepickerSelected a {
  background: #aa0000;
}

/* style the 'not in month' day cell away */
tbody.datepickerDays td.datepickerNotInMonth.datepickerSelected {
  background-color: transparent;
}

div.datepicker td.datepickerNotInMonth a span {
  display: none;
}

div.datepicker td.datepickerNotInMonth a:hover span {
  display: none;
}

div.datepicker tbody.datepickerDays td.datepickerNotInMonth:hover {
  background-color: transparent;
}

.compare {
  /*width: 220px;
  padding: 0px 0px 0px 20px;
  margin: -4px 10px 0 0;*/
  //width: 255px;
  width: 220px;
  padding: 0;
  margin: -4px 0 0 10px;
  font-size: 11px;
  text-align: left;
  border-radius: 0px;
}

.input-group {
  display: flex;
  gap: 13px;
}

.compare .form-group {
  margin-bottom: 5px;
}

.compare .control-label {
  font-size: 11px;
}

.compare input[type='text'],
.compare select {
  height: auto;
  min-height: inherit;
  padding: 5px 5px;
  font-size: 11px;
  line-height: normal;
  color: #565a65;
  text-align: left;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-radius: 3px;

  /* background: #fff; */
  -webkit-box-shadow: inset 0 1px 0 #d6d6d6;
  -moz-box-shadow: inset 0 1px 0 #d6d6d6;
  box-shadow: inset 0 1px 0 #d6d6d6;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.compare div[data-id='firstinputgroup'] input[type='text'].focus,
.compare div[data-id='firstinputgroup'] select.focus {
  border: var(--primarycolor) solid 2px;
  -webkit-box-shadow: 0px 0px 3px #8c8c8c;
  -moz-box-shadow: 0px 0px 3px #8c8c8c;
  box-shadow: 0px 0px 3px #8c8c8c;
}

.compare div[data-id='secondinputgroup'] input[type='text'].focus,
.compare div[data-id='secondinputgroup'] select.focus {
  border: #8c97ad solid 2px;
  -webkit-box-shadow: 0px 0px 3px #8c8c8c;
  -moz-box-shadow: 0px 0px 3px #8c8c8c;
  box-shadow: 0px 0px 3px #8c8c8c;
}

.compare input[type='text'].disabled,
.compare select.disabled {
  /* background: red; */
  color: #d0d0d0;
  border-top: 1px solid #ececec;
  border-right: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  border-left: 1px solid #ececec;
}

.compare select:disabled {
  opacity: 0.4;
}

.selectwrap {
  position: relative;
  display: inline-block;
  // width: 100%;
  width: 239px;
}

.selectwrap:after {
  position: absolute;
  top: 43%;
  right: 14px;
  margin-top: -8px;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  font-variant: normal;
  color: #222;
  pointer-events: none;
  content: '\2039';
  transform: rotate(-90deg);
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

[data-id^='datedistance'],
[data-id^='selectcompare'] {
  display: inline-block;
  width: 96%;
}

[data-id^='firstinputgroup'] .col-xs-6,
[data-id^='secondinputgroup'] .col-xs-6 {
  display: inline-block;
  width: 48%;
  vertical-align: top;
}

[data-id^='date1s'],
[data-id^='date1e'],
[data-id^='date2s'],
[data-id^='date2e'] {
  display: inline-block;
  width: 98%;
}
[data-id^='date1e'],
[data-id^='date2e'] {
  float: right;
}

[data-id^='chkcompare'] {
  position: absolute;
}
.compare .checkbox {
  margin-bottom: 5px;
}

/* .compare .btn {
        line-height: normal;
        font-size: 12px;
        padding: 4px 8px;
    }*/

.compare .btn {
  display: inline-block;
  padding: 5px 8px;
  font-size: 11px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  cursor: pointer;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: var(--primarycolor);
  border: 0px;
  -webkit-border-radius: 0px;
  // border-radius: 0px;
  border-radius: 3px;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -ms-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-touch-callout: none;
}
.btn.pull-right {
  margin-right: 8px;
  background-color: #c1c9d0;
}
.compare .btn-primary {
  margin-top: 1px;
  margin-right: 9px;
}

.compare .btn:hover {
  color: #fff !important;
  background-color: #424242 !important;
}

.compare .form-horizontal .control-label {
  padding-top: 3px;
  margin-bottom: 0;
  text-align: left;
}

.compare .checkbox label,
.radio label {
  display: block;
  min-height: 10px;
  padding-left: 20px;
  margin-right: 0;
  margin-bottom: 0;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.compare hr {
  display: none;
  margin-top: 5px;
  margin-bottom: 10px;
}

tbody.datepickerDays td.datepickerSelected2:not(.datepickerNotInMonth) {
  background: #8c97ad;
}

tbody.datepickerDays td.datepickerSelected.datepickerSelected2:not(.datepickerNotInMonth) {
  background: var(--primarycolor);

  /* color: red; */
}

table.datepickerViewDays {
  margin-top: 14px;
}

div.datepicker td.datepickerSelected2 a {
  color: white;
}

div.datepicker .compare .checkbox {
}

div.datepicker .compare .checkbox label:before {
  display: none !important;
  background-color: Transparent !important;
  border: none;
}

div.datepicker .compare .checkbox input[type='checkbox'] {
  display: block;
  margin-top: 2px;
  margin-left: -18px;
}

.daterangecomparepicker {
  max-width: 400px;
  padding-left: 35px;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  background: url(/content/assets/plugins/date-range-comparison-picker/calendar24px.png) no-repeat
    5px center;
  background-size: 16px;
  border: 1px solid #ccc;
}

.white-date .daterangecomparepicker {
  color: #607d8b;
  background-color: none;
}

.white-date.single-mode {
  min-height: 37px;
  padding-left: 35px !important;
  vertical-align: top;
  cursor: pointer;
  background: url(/content/assets/plugins/date-range-comparison-picker/calendar24px.png) no-repeat
    15px center !important;
  background-size: 16px !important;
  border: 1px solid #e5e9ec;
  // -webkit-border-radius: 0px;
  // -moz-border-radius: 0px;
  // -webkit-border-radius: 2px;
  // -moz-border-radius: 2px;
  // border-radius: 2px;
  // border-radius: 0px;
  border-radius: 2px;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}

.white-date.single-mode .drp-wrap {
  border: none;
}

.gray-date .daterangecomparepicker {
  color: #fff;
  background: url(/content/assets/plugins/date-range-comparison-picker/calendar16px-white.png)
    no-repeat 5px center;
  background-color: #607d8b;

  /*min-width: 400px;*/
}

.drp-wrap {
  position: relative;
  display: block;
  padding: unset;
  margin-right: unset;
  font-size: 14px;
  line-height: 1.42857143;
  color: #fff;
  background-color: #2d3138;
  background-image: none;
  border-bottom: 0px;
  border-radius: 4px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  font-family: sans-serif;
}

.drp-wrap > input {
  width: 100%;
  min-width: 220px;
  max-width: unset;
  height: auto !important;
  padding: 0 !important;
  margin-bottom: 0;
  font-size: 1.13em;
  line-height: normal;
  color: #fff;
  letter-spacing: 0.03em;
  cursor: pointer;
  background: none !important;
  border: none;
  outline: none;
  box-shadow: none !important;
  font-family: sans-serif;
}

.controls .drp-wrap > input {
  min-height: 27px;
}

.drp-wrap .compare-label {
  bottom: 0px;
  font-size: 75%;
  color: rgba(129, 140, 165, 1);
  text-align: left;
  cursor: pointer;
}

.drp-wrap .compare-label > span {
  margin-left: 5px;

  /* bottom: 0px; */

  /* font-size: 80%; */
  color: rgb(129 140 165);
  cursor: pointer;
}

.drp-wrap {
  background-color: transparent;
  border: 1px solid transparent;
}

.datepicker {
  max-width: 800px;
}
</style>

<style lang="scss" scoped>
.wrap {
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 6px 12px;
  min-width: 224px;
}
.wrap:hover {
  background-color: transparent;
  border: 1px solid rgba(170, 170, 170, 0.3);
}
.report-wrap {
  position: relative;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  min-width: 224px;
  margin-left: -8px;
  .rpt-wrap {
    font-size: 13px !important;
    padding: 6px 0px 6px 0px !important;
  }
}
.report-wrap:hover {
  background-color: transparent;
  border: 1px solid rgba(170, 170, 170, 0.3);
}
.light-theme .rpt-bldr {
  font-size: 13px !important;
  padding: 6px 0px 6px 0px !important;
}
</style>
